export const EMPTY = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [],
    "metrics": [
      "cost"
    ],
    "limit": 1000,
    "series": [],
    "totals": {}
  }
`)

export const ROLLUP_DAY = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "day",
    "timezone": "UTC",
    "timestamps": [
      1495843200,
      1495929600
    ],
    "metrics": [
      "cost"
    ],
    "limit": 1000,
    "series": [
      {
        "slice": {
          "entity": "ENTITY1"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              10,
              20
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity"
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY2"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30,
              40
            ]
          }
        ]
      }
    ],
    "totals": {
      "cost": 100
    }
  }
`)

export const ROLLUP_TOTAL = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [
      1495929600
    ],
    "metrics": [
      "cost"
    ],
    "limit": 1000,
    "series": [
      {
        "slice": {
          "entity": "ENTITY1"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity",
            "created": "20150124",
            "third_party_names": {
              "dcm": "DCM Entity"
            }
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY2"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              70
            ]
          }
        ],
        "data": {
          "entity": {
            "created": "20161230"
          }
        }
      }
    ],
    "totals": {
      "cost": 100
    }
  }
`)

export const ROLLUP_TOTAL_WITH_EMPTY_DATES = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [
      1495929600
    ],
    "metrics": [
      "cost"
    ],
    "limit": 1000,
    "series": [
      {
        "slice": {
          "entity": "ENTITY1"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity",
            "created": "",
            "third_party_names": {
              "dcm": "DCM Entity"
            }
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY2"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              70
            ]
          }
        ],
        "data": {
          "entity": {
            "created": ""
          }
        }
      }
    ],
    "totals": {
      "cost": 100
    }
  }
`)

export const LIMITED = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [
      1495929600
    ],
    "metrics": [
      "cost"
    ],
    "limit": 1,
    "next_slice": {
      "entity": "ENTITY2"
    },
    "series": [
      {
        "slice": {
          "entity": "ENTITY1"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity"
          }
        }
      }
    ],
    "totals": {
      "cost": 100
    }
  }
`)

export const EMPTY_SLICES = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [],
    "metrics": [
      "cost"
    ],
    "limit": 1000,
    "series": [
      {
        "slice": {
          "entity": null
        },
        "metrics": [
          {
            "name": "cost",
            "values": []
          }
        ]
      },
      {
        "slice": {
          "entity": ""
        },
        "metrics": [
          {
            "name": "cost",
            "values": []
          }
        ]
      }
    ],
    "totals": {}
  }
`)

export const QUERY_RESULT_MULTIPLE_DIMENSIONS = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity",
      "service"
    ],
    "rollup": "total",
    "timezone": "UTC",
    "timestamps": [
      1495929600
    ],
    "metrics": [
      "cost"
    ],
    "series": [
      {
        "slice": {
          "entity": "ENTITY1",
          "service": "SERVICE1"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity"
          },
          "service": {
            "service": "Some Service"
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY1",
          "service": "SERVICE2"
        },
        "metrics": [
          {
            "name": "cost",
            "values": [
              30
            ]
          }
        ],
        "data": {
          "entity": {
            "entity": "Some Entity"
          },
          "service": {
            "service": "Another Service"
          }
        }
      }
    ],
    "totals": {
      "cost": 60
    }
  }
`)

export const ZERO_DIMENSIONS = JSON.parse(`
  {
    "cube": [],
    "metrics": [
      "cost"
    ],
    "timestamps": [
      1495929600
    ],
    "rollup": "total",
    "timezone": "UTC",
    "series": [
      {
        "slice": {},
        "metrics": [
          {
            "name": "cost",
            "values": [
              100
            ]
          }
        ],
        "data": {}
      }
    ],
    "totals": {}
  }
`)
